export default __webpack_public_path__ + "static/media/sharelinks.86504c7a.svg";